interface OrganicDividerProps {
  variant?: "wave" | "curve" | "slant" | "wave-invert";
  fill?: "background-50" | "background-100" | "foreground-900";
  className?: string;
}

export default function OrganicDivider({
  variant = "wave",
  fill = "background-100",
  className = "",
}: OrganicDividerProps) {
  const fillMap: Record<string, string> = {
    "background-50": "oklch(var(--background-50))",
    "background-100": "oklch(var(--background-100))",
    "foreground-900": "oklch(var(--foreground-900))",
  };
  const color = fillMap[fill] || fillMap["background-100"];

  if (variant === "wave") {
    return (
      <div className={`section-divider-wave ${className}`}>
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0,40 C240,70 480,10 720,40 C960,70 1200,10 1440,40 L1440,80 L0,80 Z"
            fill={color}
          />
        </svg>
      </div>
    );
  }

  if (variant === "wave-invert") {
    return (
      <div className={`section-divider-wave ${className}`}>
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0,40 C240,10 480,70 720,40 C960,10 1200,70 1440,40 L1440,0 L0,0 Z"
            fill={color}
          />
        </svg>
      </div>
    );
  }

  if (variant === "curve") {
    return (
      <div className={`section-divider-curve ${className}`}>
        <div
          className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[120%] h-[60px] rounded-[50%_50%_0_0]"
          style={{ backgroundColor: color }}
        />
      </div>
    );
  }

  if (variant === "slant") {
    return (
      <div className={`relative h-16 md:h-20 overflow-hidden ${className}`}>
        <div
          className="absolute bottom-0 left-0 w-full h-full"
          style={{
            background: `linear-gradient(175deg, transparent 49.5%, ${color} 50%)`,
          }}
        />
      </div>
    );
  }

  return null;
}